import { startOfDay } from "date-fns";
import * as z from "zod";
import { requiredErrorMessage } from "../common/error-messages";

export const appointmentServiceLineSchema = z.object({
  staff_id: z.number().min(1, requiredErrorMessage),
  service_id: z.number().min(1, requiredErrorMessage),
  start_time: z.string().min(1, requiredErrorMessage),
  duration_minutes: z.number().min(1).max(1440),
  price: z.number().min(0).max(999999999),
});

export const addAppointmentSchema = (today: Date) =>
  z.object({
    client_id: z.number().min(1, requiredErrorMessage),
    appointment_date: z.date().refine(
      (date) => startOfDay(date) >= today,
      { message: requiredErrorMessage }
    ),
    status: z.literal("booked"),
    services: z.array(appointmentServiceLineSchema).min(1),
  });

export type AddAppointmentFormValues = z.infer<ReturnType<typeof addAppointmentSchema>>;
